namespace RedBullMOBILE360.CustomerCare {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.CustomerCare.ThreeThreeZeroNotificationGrid')
    export class ThreeThreeZeroNotificationGrid extends Serenity.EntityGrid<ThreeThreeZeroNotificationRow, any> {
        protected getColumnsKey() { return ThreeThreeZeroNotificationColumns.columnsKey; }
        protected getDialogType() { return ThreeThreeZeroNotificationDialog; }
        protected getIdProperty() { return ThreeThreeZeroNotificationRow.idProperty; }
        protected getInsertPermission() { return ThreeThreeZeroNotificationRow.insertPermission; }
        protected getLocalTextPrefix() { return ThreeThreeZeroNotificationRow.localTextPrefix; }
        protected getService() { return ThreeThreeZeroNotificationService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected override getButtons(): Serenity.ToolButton[] {
            let buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(Serenity.Extensions.ExcelExportHelper.createToolButton({
                title: 'Export to Excel', grid: this, service: ThreeThreeZeroNotificationService.baseUrl + '/ListExcel', onViewSubmit: () => this.onViewSubmit()
            }));

           buttons.push({
                title: 'Import List of numbers',
                cssClass: 'import-button',
                onClick: () => {
                    var dialog = new ThreeThreeZeroNotificationExcelImportDialog();
                    dialog.dialogOpen();
                }
            });

            buttons.push(Serenity.Extensions.ExcelExportHelper.createToolButton({
                title: 'Download Template',
                grid: this,
                service: ThreeThreeZeroNotificationService.baseUrl + '/DownloadTemplate',
                onViewSubmit: () => this.onViewSubmit()
            }));

            return buttons;
        }

        protected getColumns() {
            var columns = super.getColumns();

            const canClose = Q.Authorization.hasPermission("CustomerCare:ThreeThreeZeroNotification");
            const canResume = Q.Authorization.hasPermission("CustomerCare:ManualResume");
            const canUpdatePeriod = Q.Authorization.hasPermission("CustomerCare:UpdateActionPeriod");
            if (canClose || canResume || canUpdatePeriod) {
                columns.push({
                    field: 'Id',
                    name: '',
                    width: 340,
                    format: ctx => {
                        const updateTypeList = [
                            { code: 4, value: "Already Suspended", description: "The number has already been suspended for other reasons", timeFrame: 8, status: 1, reasonCodes: [] },
                            { code: 5, value: "Terminate", description: "Permanently disconnect the number", timeFrame: 8, status: 0, reasonCodes: [] },
                            { code: 6, value: "Already Terminated", description: "The number has already been disconnected permanently for other reasons", timeFrame: 8, status: 0, reasonCodes: [] },
                            { code: 7, value: "Transferred To Other Operator", description: "The number has been transferred to another operator", timeFrame: 8, status: 0, reasonCodes: [] },
                            { code: 8, value: "False Complaint", description: "The complaint is false", timeFrame: 8, status: 0, reasonCodes: [{ code: 1, description: "Fraudulent complaint" }, { code: 2, description: "Testing by the operator" }] },
                            { code: 9, value: "Block", description: "Block the number for 90 days ", timeFrame: 8, status: 0, reasonCodes: [{ code: 3, description: "International number" }] },
                            { code: 10, value: "Terminate", description: "Permanently disconnect the number", timeFrame: 10, status: 0, reasonCodes: [{ code: 4, description: "No update from customer" }, { code: 5, description: "Valid complaint" }, { code: 6, description: "Requested from operator" }, { code: 7, description: "Requested from CST" }] },
                            { code: 11, value: "Resume", description: "Reactivate the number", timeFrame: 10, status: 0, reasonCodes: [{ code: 8, description: "Updated from customer" }, { code: 9, description: "Requested from operator" }, { code: 10, description: "Requested from CST" }] },
                            { code: 12, value: "Change Ownership", description: "the number has been transferred to another owner", timeFrame: 8, status: 0, reasonCodes: [] },
                            { code: 13, value: "Suspend", description: "Suspend the number temporarily", timeFrame: 8, status: 1, reasonCodes: [] },
                            { code: 14, value: "Whitelist", description: "The client is in a whitelist", timeFrame: 8, status: 0, reasonCodes: [] }
                        ];

                        const options = updateTypeList.map(item => {
                            return `<option value="${item.code}">${item.value}</option>`;
                        }).join('');

                        const uniqueId = `row_${ctx.index}`;
                        const status = ctx.item.Status;
                        const statusLower = (status || '').toLowerCase();

                        if (statusLower === 'inprogress' && (canResume || canUpdatePeriod)) {
                            const period = ctx.item.ExtraActionPeriodDays;
                            // Resume is allowed for any notification source.
                            let html = '<div class="d-flex align-items-center gap-2 me-5">';

                            if (canUpdatePeriod) {
                                const curVal = (period !== null && period !== undefined) ? String(period) : '';
                                html += `
                            <form action="/ThreeThreeZeroNotification/UpdateActionPeriod/" method="get" class="d-inline"
                                onsubmit="var d=parseInt(this.days.value,10); if(isNaN(d)||d<0||d>60){alert('Extra action period must be a number between 0 and 60 days.');return false;} return confirm('Set extra action period to '+d+' days (added on top of the standard period)?');">
                                <input class="d-none" name="NotifyId" value="${ctx.value}" type="text">
                                <input name="days" type="number" min="0" max="60" step="1" value="${curVal}"
                                    class="form-control form-control-sm d-inline" style="width:70px" placeholder="Extra" title="Extra action period in days (0-60), added on top of the standard period">
                                <button class="text-primary p-0 btn fw-bold ms-1" type="submit" data-bs-toggle="tooltip" data-bs-placement="top" title="Save extra action period">
                                    Save
                                </button>
                            </form>`;
                            }

                            if (canResume) {
                                html += `
                            <form action="/ThreeThreeZeroNotification/ResumeFraudCase/" method="get" onsubmit="return confirm('Resume this number?')">
                                <input class="d-none" name="NotifyId" value="${ctx.value}" type="text">
                                <button class="text-success p-0 btn fw-bold" type="submit" data-bs-toggle="tooltip" data-bs-placement="top" title="Resume number">
                                    Resume
                                </button>
                            </form>`;
                            }

                            html += '</div>';
                            return html;
                        }

                        if (status === 'open' && canClose) {
                            return `
                        <form action="/ThreeThreeZeroNotification/CloseNotification/" method="get" onsubmit="return prepareFormData(this)">
                            <div class="d-flex align-items-center gap-2 me-5">
                                <input class="d-none" name="NotifyId" value="${ctx.value}" type="text">
                                <select required name="actionType" class="form-select w-100" data-notify-id="${ctx.value}" data-update-type-list='${JSON.stringify(updateTypeList)}' onchange="populateReasonCodes(this)">
                                    <option value="">Action</option>
                                    ${options}
                                </select>
                                <select name="reasonCode" class="form-select w-100 reasonCodeSelect" style="display: none;">
                                    <option value="">Reason</option>
                                </select>
                                <input type="hidden" name="code" class="codeInput">
                                <input type="hidden" name="value" class="valueInput">
                                <input type="hidden" name="description" class="descriptionInput">
                                <input type="hidden" name="timeFrame" class="timeFrameInput">
                                <input type="hidden" name="status" class="statusInput">
                                <input type="hidden" name="reasonCodeData" class="reasonCodeDataInput">
                                <button class="text-danger p-0 btn fw-bold" type="submit" data-bs-toggle="tooltip" data-bs-placement="top" title="Close notification"> 
                                    Close
                                </button>
                            </div>
                        </form>`;
                        } else {
                            return '';
                        }
                    }
                });
            }

            window.populateReasonCodes = (select) => {
                const updateTypeList = JSON.parse(select.getAttribute('data-update-type-list'));
                const selectedCode = parseInt(select.value);
                const selectedAction = updateTypeList.find(item => item.code === selectedCode);
                const form = select.closest('form');

                if (selectedAction) {
                    form.querySelector('.codeInput').value = selectedAction.code;
                    form.querySelector('.valueInput').value = selectedAction.value;
                    form.querySelector('.descriptionInput').value = selectedAction.description;
                    form.querySelector('.timeFrameInput').value = selectedAction.timeFrame;
                    form.querySelector('.statusInput').value = selectedAction.status;

                    const reasonCodeSelect = form.querySelector('.reasonCodeSelect');
                    if (selectedAction.reasonCodes.length > 0) {
                        const options = selectedAction.reasonCodes.map(reason => {
                            return `<option value="${reason.code}">${reason.description}</option>`;
                        }).join('');
                        reasonCodeSelect.innerHTML = '<option value="">Reason</option>' + options;
                        reasonCodeSelect.style.display = 'block';
                    } else {
                        reasonCodeSelect.innerHTML = '<option value="">Reason</option>';
                        reasonCodeSelect.style.display = 'none';
                    }
                }
            };

            window.prepareFormData = (form) => {
                const reasonCodeSelect = form.querySelector('select[name="reasonCode"]');
                if (reasonCodeSelect) {
                    const selectedReasonCode = reasonCodeSelect.options[reasonCodeSelect.selectedIndex];
                    if (selectedReasonCode && selectedReasonCode.value) {
                        form.querySelector('.reasonCodeDataInput').value = JSON.stringify({
                            code: selectedReasonCode.value,
                            description: selectedReasonCode.text
                        });
                    }
                }
                return true;
            };

            return columns;
        }
    }
}